"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Filter = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _react.default.createElement("path", {
  className: "fill",
  d: "M13.6 0H2.4A2.4 2.4 0 000 2.4v.936c0 .33.068.657.2.96v.048c.113.257.273.49.472.688L5.6 9.928V15.2a.8.8 0 00.8.8.8.8 0 00.36-.088l3.2-1.6a.8.8 0 00.44-.712V9.928l4.896-4.896c.199-.198.359-.431.472-.688v-.048a2.4 2.4 0 00.232-.96V2.4A2.4 2.4 0 0013.6 0zm.8 3.2H1.6v-.8a.8.8 0 01.8-.8h11.2a.8.8 0 01.8.8v.8z",
  fillRule: "nonzero"
}));

var _default = Filter;
exports.default = _default;